export default "__VITE_ASSET__BUDNyyq8__"